import { useState, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Menu } from 'lucide-react'
import Sidebar from '@/components/Sidebar'
import ImpersonationBanner from '@/components/ImpersonationBanner'
import TenantStatusBanner from '@/components/TenantStatusBanner'
import GodModeBanner from '@/components/GodModeBanner'
import MobileTopActions from '@/components/MobileTopActions'
import ClientBrandingApplier from '@/components/ClientBrandingApplier'

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { pathname } = useLocation()

  useEffect(() => { window.scrollTo(0, 0) }, [pathname])

  return (
    <div className="min-h-screen bg-bg">
      <ClientBrandingApplier />
      {/* FAB Menu — só em mobile. Fica acima do conteúdo, sem ocupar 56px
          fixos de barra no topo. O conteúdo usa a viewport inteira. */}
      <button
        onClick={() => setSidebarOpen(true)}
        className="lg:hidden fixed top-3 left-3 z-40 w-10 h-10 rounded-full flex items-center justify-center text-text backdrop-blur-md shadow-sm transition-colors"
        style={{ background: 'color-mix(in oklch, var(--color-bg) 70%, transparent)', boxShadow: '0 0 0 1px var(--color-card-border)' }}
        aria-label="Abrir menu"
      >
        <Menu className="w-5 h-5" />
      </button>

      {/* Top-right actions (theme + notifications) — mobile only */}
      <MobileTopActions />

      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="lg:ml-60 p-4 lg:p-8">
        <Outlet />
      </main>

      {/* Banners flutuantes no canto inferior direito — não tampam conteúdo */}
      <ImpersonationBanner />
      <GodModeBanner />
      <TenantStatusBanner />
    </div>
  )
}
